'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import Link from 'next/link';

interface BackButtonProps {
  href?: string;
  label?: string;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const BackButton: React.FC<BackButtonProps> = ({
  href,
  label = 'بازگشت',
  className = '',
  onClick,
}) => {
  const router = useRouter();

  const handleBack = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
      return;
    }
    if (!href) {
      e.preventDefault();
      router.back();
    }
  };

  const buttonContent = (
    <>
      <div className="w-8 h-8 rounded-full bg-[#206A4F]/10 dark:bg-white/10 group-hover:bg-white/25 flex items-center justify-center transition-all duration-200 shrink-0">
        <ArrowRight size={18} className="hidden rtl:inline-block text-[#206A4F] dark:text-emerald-400 group-hover:text-current transition-transform duration-200 group-hover:translate-x-1" />
        <ArrowLeft size={18} className="inline-block rtl:hidden text-[#206A4F] dark:text-emerald-400 group-hover:text-current transition-transform duration-200 group-hover:-translate-x-1" />
      </div>
      <span className="font-extrabold text-sm tracking-wide">{label}</span>
    </>
  );

  const baseClasses = `group inline-flex items-center gap-3 px-5 py-2.5 rounded-full text-[#206A4F] dark:text-emerald-300 bg-white/90 dark:bg-[#1A2620]/90 backdrop-blur-xl border border-[#206A4F]/20 dark:border-white/20 shadow-md hover:shadow-xl hover:bg-[#206A4F] hover:text-[#F5F0E8] dark:hover:bg-emerald-500 dark:hover:text-zinc-950 transition-all duration-200 cursor-pointer active:scale-95 select-none ${className}`;

  if (href) {
    return (
      <Link href={href} className={baseClasses} onClick={onClick}>
        {buttonContent}
      </Link>
    );
  }

  return (
    <button type="button" onClick={handleBack} className={baseClasses}>
      {buttonContent}
    </button>
  );
};
